import { useDispatch } from "react-redux";
import { AppDispatch } from "store/store";
import { setSelectedIndex } from "../../../store/slices/DocsSlice";
import { DocsTab } from "../../../shared/enums/DocsTabEnum";
import PromineoHowItWorksButton from "../../../components/common/controls/PromineoHowItWorksButton";
import { useHistory } from "react-router";
import * as routePath from "shared/constants/RoutePathConstants";

export default function TryThisAtHome() {
  const dispatch = useDispatch<AppDispatch>();
  const history = useHistory();

  const handleViewExamplesClick = () => {
    dispatch(setSelectedIndex(DocsTab.ViewExamples));
  };

  const handleCreateTokenClick = () => {
    history.push(routePath.TOKENS);
  };

  const handleGotoDevelopersSectionClick = () => {
    dispatch(setSelectedIndex(DocsTab.DevelopersSection));
  };

  const TryOption = ({ text, children }: { text: string; children: any }) => {
    return (
      <div>
        <div className="text-base font-inter">{text}</div>
        <div className="mt-3">{children}</div>
      </div>
    );
  };

  return (
    <>
      <div className="font-inter font-bold text-24px leading-29px">
        Try this at home!
      </div>
      <div className="mt-8 space-y-8">
        <TryOption text="We have prepared examples for you in Excel and Power BI. This gives you the opportunity to experience timePhasing in its proper context. You can run the examples using provided input data, or you can replace them with your own to get started with time-phasing of your data. Give them a spin with the View examples button below.">
          <PromineoHowItWorksButton
            text="View examples here"
            onClick={handleViewExamplesClick}
          />
        </TryOption>

        <TryOption text="Ready to get started? You need to provide a token key to use the timePhasing service. Click below button to enter the Tokens page and create your own personal key.">
          <PromineoHowItWorksButton
            text="Create a token to access the service"
            onClick={handleCreateTokenClick}
          />
        </TryOption>

        <TryOption text="Want to read more about the service? Visit the developers section for a more comprehensive API documentation by clicking button below.">
          <PromineoHowItWorksButton
            text="Developers section"
            onClick={handleGotoDevelopersSectionClick}
          />
        </TryOption>
      </div>
    </>
  );
}
